<template>
  <div class="a-control" v-if="curPlay">
    <div class="rate iconfont icon-beisu" @click="bindSetRate">
      <div class="rate-text">{{ curPlay.rate | filterRateText }}</div>
    </div>
    <div class="content">
      <div class="btn-15s retreat-btn" @click="bindBackTime">
        <span class="btn-15-text">{{ jumpTime }}</span>
        <span class="iconfont icon-houtui"></span>
      </div>
      <div class="progress-container">
        <div
          class="progress-padding"
          ref="progress"
          @touchstart="bindTouchStart"
          @touchmove="bindTouchMove"
          @touchend="bindTouchEnd"
          @touchcancel="bindTouchCatch"
        >
          <div class="a-progress">
            <div class="cur-progress" :style="{ width: curWidth }"> </div>
            <div
              class="time-content"
              ref="time"
              v-if="
                (curPlay.totalTime && curPlay.curTime) || curPlay.disabledMove
              "
              :style="{ left: curLeft }"
              >{{ curTimeText }}/{{ totalTimeText }}</div
            >
          </div>
        </div>
      </div>
      <div class="btn-15s fast-btn" @click="bindFrontTime">
        <span class="btn-15-text">{{ jumpTime }}</span>
        <span class="iconfont icon-kuaijin"></span>
      </div>
    </div>
    <div class="control-box">
      <div class="c-btn-item pre" @click="bindPre"
        ><span class="iconfont icon-zuohoutui"></span
      ></div>
      <div class="toggle" @click="bindToggle">
        <span class="iconfont icon-24gf-play" v-show="!curPlay.play"></span>
        <span class="iconfont icon-zanting" v-show="curPlay.play"></span>
      </div>
      <div class="c-btn-item next" @click="bindNext"
        ><span class="iconfont icon-youqianjin"></span
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default:
        'https://gymvue.gymcity.com.cn/assets/mp3/%E9%95%9C%E4%BA%88%E6%AD%8C_%E5%96%A7%E7%AC%91_%E9%99%88%E4%BA%A6%E6%B4%BA-%E6%99%9A%E5%A4%9C%E5%BE%AE%E9%9B%A8%E9%97%AE%E6%B5%B7%E6%A3%A0.mp3'
    },
    player: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      jumpTime: 15, //前进后退时间
      cur: 0
    }
  },
  filters: {
    filterRateText(rate) {
      return rate.toFixed(1) + 'X'
    }
  },
  watch: {},
  computed: {
    curPlay() {
      return this.player?.playList[this.player.index] || null
    },
    curWidth() {
      return (this.curPlay.curTime / this.curPlay.totalTime) * 100 + '%'
    },
    curLeft() {
      let res = this.curPlay.curTime / this.curPlay.totalTime
      let min = 0.1
      let max = 0.9
      res = res < min ? min : res > max ? max : res
      return res * 100 + '%'
    },
    totalTimeText() {
      return this.getTimeStr(this.curPlay.totalTime)
    },
    curTimeText() {
      return this.getTimeStr(this.curPlay.curTime)
    }
  },
  created() {},
  mounted() {},
  methods: {
    bindPre() {},
    bindNext() {},
    bindSetRate() {
      this.$emit('rate')
    },
    bindToggle() {
      this.$emit('toggle')
    },
    getTimeStr(times) {
      let hours = Math.floor(times / (60 * 60))
      let min = Math.floor((times % (60 * 60)) / 60)
      let second = Math.round((times % (60 * 60)) % 60)
      hours = hours ? (hours <= 9 ? '0' + hours : hours) : ''
      min = min ? (min <= 9 ? '0' + min : min) : '00'
      second = second <= 9 ? '0' + second : second
      hours = hours ? hours + ':' : ''
      min = min + ':'
      return hours + min + second
    },
    bindTouchStart(e) {
      let el = this.$refs.progress
      this.curPlay.disabledMove = true
      this.updatePercent(e, el)
      console.log('触摸开始')
    },
    bindTouchMove(e) {
      let el = this.$refs.progress
      this.updatePercent(e, el)
      console.log('触摸移动')
    },
    bindTouchEnd(e) {
      this.curPlay.disabledMove = false
      console.log('触摸结束')
      // this.player.seek(this.curPlay.curTime);
      this.$emit('jump', this.curPlay.curTime)
      // this.$emit("changeEnd");
    },
    bindTouchCatch() {
      this.curPlay.disabledMove = false
      console.log('触摸取消')
      this.player.seek(this.curPlay.curTime)
    },
    updatePercent(e, el) {
      let pecent = this.computedPercent(e, el)
      this.curPlay.curTime = Math.round(this.curPlay.totalTime * pecent)
    },
    computedPercent(e, el) {
      if (e.touches.length !== 1) {
        return
      }
      let totalWidth = el.clientWidth
      let curWidth = e.touches[0].clientX - el.offsetLeft
      curWidth =
        curWidth < 0 ? 0 : curWidth > totalWidth ? totalWidth : curWidth
      return parseFloat((curWidth / totalWidth).toFixed(2))
    },
    bindFrontTime() {
      this.$emit('front', this.jumpTime)
    },
    bindBackTime() {
      this.$emit('back', this.jumpTime)
    }
  }
}
</script>
<style lang="scss" scoped>
.a-control {
  margin-top: 16px;

  .rate {
    position: relative;
    width: 30px;
    height: 30px;
    font-size: 30px;
    margin: 0 auto 20px;
    color: rgba(0, 0, 0, 0.3);
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;

    .rate-text {
      position: absolute;
      left: 50%;
      top: 55%;
      transform: translate(-50%, -50%);
      font-size: 10px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.3);
      line-height: 12px;
    }
  }

  .progress-container {
    width: 261px;

    .progress-padding {
      padding: 6px 0px;
    }
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-15s {
      width: 21px;
      height: 21px;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.3);
      position: relative;

      .btn-15-text {
        white-space: nowrap;
        position: absolute;
        left: 45%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 14px;
      }

      .iconfont {
        color: rgba(174, 174, 174, 1);
        font-size: 22px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .retreat-btn {
      .btn-15-text {
        left: 55%;
      }
    }
  }

  .a-progress {
    position: relative;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 1px;

    .cur-progress {
      position: relative;
      background: #6236ff;
      border-radius: 2px;
      width: 0%;
      height: 100%;
    }

    .time-content {
      white-space: nowrap;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      left: 0;
      top: 50%;
      padding: 0px 5px;
      height: 20px;
      background: #404040;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      font-size: 9px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      transform: translate(-50%, -50%);
    }
  }

  .control-box {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    .c-btn-item {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        font-size: 24px;
        color: #666;
        //color: rgba(0, 0, 0, 0.3);
      }
    }

    .pre {
    }

    .toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 53px;
      height: 53px;
      margin: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #666666;
      border-radius: 50%;
      box-sizing: border-box;

      .iconfont {
        font-size: 18px;
        color: #6236ff;
      }
    }

    .next {
    }
  }
}
</style>
